import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { IoCheckmarkSharp } from "react-icons/io5";
import { MdOutlinePlayLesson } from "react-icons/md";

const Accordion = ({ outerText, onClick, compare, open, innerText }) => {
  return (
    <div className="p-2 py-5 bg-white shadow rounded-md border-b-[1px] border-[#eaebf0]">
      <div onDoubleClick={onClick} className="flex justify-between pb-3">
        <p className="sm:text-xl text-lg font-bold ">{outerText}</p>
        <div className="text-xl" onClick={onClick}>
          {compare ? (
            <IoMdArrowDropdown />
          ) : open ? (
            <IoMdArrowDropup />
          ) : (
            <IoMdArrowDropdown />
          )}
        </div>
      </div>
      <div
        className={`${
          compare ? "hidden" : open ? "block" : "hidden"
        } border-t-[1px]  py-5 hover:text-[#66B2FF]`}
      >
        <div className="flex justify-between ">
          <div className="flex gap-3">
            <MdOutlinePlayLesson className="text-[#004C97] text-2xl" />
            <p className="font-bold">{innerText}</p>
          </div>
          <IoCheckmarkSharp className="text-[#3b76db] text-xl" />
        </div>
      </div>
    </div>
  );
};

export default Accordion;
